import {
  mockBasketItem,
  mockBasketItemQuoteDetails,
} from '@domgen/dgx-fe-basket';
import { mockBrandRetailer } from '@domgen/dgx-fe-catalogue';
import {
  ClientBrandCode,
  ClientCode,
  ClientGroupCode,
} from '@domgen/dgx-fe-common';
import { RegistrationApplianceDetails } from '../../models/registration-appliance-details/registration-appliance-details.interface';

export const mockRegistrationApplianceDetails: RegistrationApplianceDetails = {
  applianceCode: 'CN',
  applianceName: 'American Fridge Freezer',
  basketItemId: mockBasketItem.itemId,
  basketQuoteId: mockBasketItemQuoteDetails.quoteId,
  brandCode: ClientBrandCode.AEG,
  brandName: 'AEG',
  clientCode: ClientCode.AEG,
  clientGroupCode: ClientGroupCode.ABElectrolux,
  id: 'id',
  modelNumber: undefined,
  purchaseDay: new Date().getDate(),
  purchaseMonth: new Date().getMonth() + 1,
  purchasePrice: 300,
  purchaseYear: new Date().getFullYear(),
  retailer: mockBrandRetailer.name,
  serialNumber: undefined,
  warranty: 12,
};
